module.exports = __webpack_public_path__ + "static/media/INZ1146.0ced2357.pdf";